import { Component } from '@angular/core';
import { ApiService } from '../services/contratos/contratos.service';
import { MatDialog } from '@angular/material/dialog';
import { CarregaService } from '../services/carrega_file/carrega.service';
import { HttpClient } from '@angular/common/http';
import { DatePipe } from '@angular/common';

@Component({
    selector: 'app-planilha-input-diretos',
    templateUrl: './planilha-input-diretos.component.html',
    styleUrls: ['./planilha-input-diretos.component.css'],
    standalone: false
})
export class PlanilhaInputDiretosComponent {
  item: any = {
    fornecedor: '',
    qtdEntregas: 0,
    horarios: [],
    pontoDescarga: ''
  };
  urlAtualiza: string = 'https://uj88w4ga9i.execute-api.sa-east-1.amazonaws.com/dev12';
  urlConsulta: string = 'https://fopq9ohj7e.execute-api.sa-east-1.amazonaws.com/v1';
  urlConsultaTrips: string = 'https://qu0d5gqb4g.execute-api.sa-east-1.amazonaws.com/v1/';
  queryDiretasPlanilha: string = 'Viagens-LCB-Diretas';
  dataLoaded = false;
  jsonData: any;
  sortColumn: string = '';
  sortDirection: number = 1;
  startDate!: Date;
  endDate: Date = new Date();
  dialogOpen!: boolean;
  isLoading: boolean = true;
  programacaoDiretas: any[] = [];
  tabelaDia: boolean = false;
  clickedButtons: { [key: string]: boolean } = {'seg': true};
  diaSelect: string = 'seg';
  programacaoDiretasFiltradas!: any[];
  totalMU: number = 0;
  totalFornecedores: number = 0;

  constructor(
    private carregaService: CarregaService,
    private http: HttpClient,
    private dynamodbService: ApiService,
    public dialog: MatDialog,
    private datePipe: DatePipe
  ) { }

  async ngOnInit() {
    await this.upDate();
  }

  async upDate() {
    await this.getProgramacaoDiretasFromDynamoDB();
    await this.somaMU();
    this.carregaViagensNaTimeTable()
    this.isLoading = false;
  }

  somaMU() {
    this.totalMU = 0;
    this.totalFornecedores = 0;
    if(this.programacaoDiretasFiltradas){
    this.programacaoDiretasFiltradas.forEach(item => {
     this.totalMU += parseFloat(item.quantidadeMU) 
    })
    this.totalFornecedores = this.programacaoDiretasFiltradas.length
  }
  }

  async abrirTabela(dia: string) {
    Object.keys(this.clickedButtons).forEach(key => {
      if (key !== dia) {
        this.clickedButtons[key] = false;
      }
    });
    this.diaSelect = dia;
    this.clickedButtons[dia] = !this.clickedButtons[dia];
    this.programacaoDiretasFiltradas = await this.programacaoDiretas.filter(item => {
      return (item.diaSemana == this.diaSelect);
    });
    await this.somaMU();
    // console.log(`Propriedade ${dia} foi definida como:`, this.clickedButtons[dia]);
  }

  inserirNova() {
    this.item = {
      fornecedor: '',
      qtdEntregas: 0,
      horarios: [],
      pontoDescarga: ''
    };
    const dataAtual = new Date();
    this.item.ID = dataAtual.getTime().toString();
    // console.log(this.item)
    this.dialogOpen = true;
  }

  editDialog(item: any): void {
    this.item = {...item}
    this.dialogOpen = true;
  }

  updateHorarios() {
    const qtd = parseInt(this.item.qtdEntregas, 10) || 0;
    this.item.horarios = new Array(qtd).fill({}).map((_, i) => ({ hora: '' }));
  }

  removerHorario(index: number) {
    this.item.horarios.splice(index, 1);
  }

  async salvar2(item: any) {
    this.isLoading = true;
    this.item = { ...item };
    this.item.tableName = this.queryDiretasPlanilha;
    this.item.diaSemana = this.diaSelect;
    // console.log(this.item); // Verifique a estrutura antes de enviar
    // Certifique-se de que os contatos estão sendo preservados
    if (!this.item.horarios || !Array.isArray(this.item.horarios)) {
      console.error('Contatos não estão presentes ou não são um array.');
      this.isLoading = false;
      return;
    }
    try {
      await this.dynamodbService.salvar([this.item], this.queryDiretasPlanilha, this.urlAtualiza).subscribe(async response => {
        await this.upDate();
        this.dialogOpen = false;
        this.isLoading = false;
      }, error => {
        console.log(error);
        this.isLoading = false;
      });
    } catch (error) {
      console.log(error);
      this.isLoading = false;
    }
  }

  cancel(): void {
    this.dialogOpen = false;
  }

  async getProgramacaoDiretasFromDynamoDB(): Promise<void> {
    const lambdaEvent = {
      "tableName": this.queryDiretasPlanilha,
      "searchConditions": [
        // { "column": "status", "word": "Completed", "negate": true },
        // { "column": "status", "word": "Canceled", "negate": true },
        // { "column": "Finalizada", "word": "true", "negate": true },
        // { "column": "Finalizada", "word": "True", "negate": true },
        // { "column": "ID", "word": "", "negate": true }
      ]
    };
    const response: any = await new Promise(async (resolve, reject) => {
      (await this.dynamodbService.getItemsFiltroColuna(lambdaEvent, this.urlConsultaTrips, 'filtro')).subscribe(
        (res: any) => resolve(res),
        (error: any) => reject(error)
      );
    });
    if (response.statusCode == 200) {
      try {
        const items = await JSON.parse(response.body);
        if (Array.isArray(items)) {
          this.programacaoDiretas = items;
          this.programacaoDiretasFiltradas = this.programacaoDiretas.filter(item => {
            return (item.diaSemana == this.diaSelect);
          });
          
        } else {
          console.error('Invalid items data:', items);
        }
      } catch (error) {
        console.error('Error parsing JSON:', error);
      }
    } else {
      console.error('Invalid response:', response);
    }
  }

  carregaViagensNaTimeTable() {
    const dataAtual = new Date();
    // Obter o dia da semana atual (0 - Domingo, 1 - Segunda, ..., 6 - Sábado)
    const diasSemana = ["Domingo", "Segunda-feira", "Terça-feira", "Quarta-feira", "Quinta-feira", "Sexta-feira", "Sábado"];
    const diaSemana = diasSemana[dataAtual.getDay()];
    // Obter o dia atual (1 - 31)
    const diaAtual = dataAtual.getDate();
    // Obter a hora atual (HH:MM:SS)
    const horaAtual = dataAtual.toLocaleTimeString();

    // console.log(`Data atual: ${dataAtual}`);
    // console.log(`Dia da semana: ${diaSemana}`);
    // console.log(`Dia atual: ${diaAtual}`);
    // console.log(`Hora atual: ${horaAtual}`);
}

  async deleteItem(ID: string): Promise < void> {
  await this.dynamodbService.deleteItem(ID, this.urlAtualiza, this.queryDiretasPlanilha).subscribe(
    async response => {
      await this.upDate();
    },
    error => {
    }
  );
}
}
